import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import VueAnalytics from 'vue-analytics'
import JsonExcel from 'vue-json-excel'
import VueTheMask from 'vue-the-mask'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
// Before all components are loaded (to avoid erasing components styling)
import './theme/index.scss'
// Import our custom spinner plugin
import CustomSpinner from './plugins/custom-spinner'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import './components'
import LazyLoadDirective from './directives/LazyLoadDirective'
import { setupAxios } from '@/services/http-common'
import L from 'leaflet'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import '@/theme/leaflet.overwrite.css'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'

// Corriger les chemins d'icônes par défaut de Leaflet
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

Vue.config.productionTip = false
Vue.directive('lazyload', LazyLoadDirective)

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  }
})
Vue.use(VueTheMask)
Vue.use(VueMoment, {
  moment
})
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueAnalytics, {
  id: processEnvConfig.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
  ignoreRoutes: ['/login']
})

Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL, // Your API domain
  providers: {
    google: {
      clientId: processEnvConfig.VUE_APP_GOOGLE_CLIENT_ID,
      requiredUrlParams: ['scope', 'access_type'],
      scope: ['profile', 'email', 'https://www.googleapis.com/auth/business.manage'],
      accessType: 'offline'
    }
  }
})

Vue.use(CustomSpinner)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

router.beforeEach(async (to, from, next) => {
  await store.restored
  next()
})

setupAxios()
